import { render, staticRenderFns } from "./contactsAdd.vue?vue&type=template&id=dde97e92&"
import script from "./contactsAdd.vue?vue&type=script&lang=js&"
export * from "./contactsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports